package com.fireavert.events.active_events.client.presentation

import com.fireavert.events.active_events.data_models.ActiveEventWithActions

data class ActiveEventsV2ViewState(
    val eventsWithActions: List<ActiveEventWithActions> = emptyList()
)
